export enum SalvageRequestQualifyType {
  'Overage' = 'OVERAGE',
  'Refused' = 'REFUSED',
  'Refuse Damaged' = 'REFUSED_DAMAGED',
  'Damage Claim Paid' = 'DAMAGE_CLAIM_PAID',
  'Abandoned' = 'ABANDONED',
}
